import { IntlShape } from "react-intl";
import { z } from "zod";

/**
 * Validation for the chronology event editor. Only `detail` is required (it is
 * the one mandatory field on the create endpoint); everything else is optional.
 */
export const createChronologyEventSchema = (intl: IntlShape) =>
  z.object({
    eventDate: z.date().nullable(),
    detail: z
      .string()
      .trim()
      .min(
        1,
        intl.formatMessage({ id: "chronology.validation.detailRequired" })
      ),
    eventType: z.string(),
    provider: z.string(),
    facility: z.string(),
    documentCategory: z.string(),
    providerSpecialty: z.string(),
    sourcePage: z.string().refine(
      (value) => {
        const trimmed = value.trim();
        if (trimmed.length === 0) return true;
        const parsed = Number(trimmed);
        return Number.isInteger(parsed) && parsed > 0;
      },
      {
        message: intl.formatMessage({
          id: "chronology.validation.sourcePageInvalid",
        }),
      }
    ),
    batesNumber: z.string(),
    pageId: z.string().optional(),
  });
